module.exports = __webpack_public_path__ + "images/emoji/metro.025d55821e6eec8fa8dd.png";